let date = new Date();
export default {
    dateType: 1,
    dates: [
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear()
    ],
    CurrencyId: [],
    InvoiceSumFrom: 0,
    InvoiceSumTo: 0,
    PayStates: [],

    PaymentOperationId: '',
    CategoryId: '',
    PaymentTypeIds: [],

    CashList: [],
    PaymentAccountList: [],


    ContragentId: '',
    ContragentName: '',
    ContragentSearchTypeId: '',
    ManagerList: [],
    DepartmentList: [],
    OnlyOverdue: false,

    KindOfPayId: '',
    AccountNumber: '',
    AgreementCode: '',
}